import { CurrencyAmount, METIS, JSBI } from '@hyperjump-defi/sdk'
import { MIN_ETH } from '../constants'

/**
 * Given some token amount, return the max that can be spent of it
 * @param currencyAmount to return max of
 */
export function maxAmountSpend(currencyAmount?: CurrencyAmount): CurrencyAmount | undefined {
  if (!currencyAmount) return undefined
  if (currencyAmount.currency === METIS) {
    if (JSBI.greaterThan(currencyAmount.raw, MIN_ETH)) {
      return CurrencyAmount.metis(JSBI.subtract(currencyAmount.raw, MIN_ETH))
    }
    return CurrencyAmount.metis(JSBI.BigInt(0))
  }
  return currencyAmount
}

export default maxAmountSpend
